import { TranslationText } from 'components/TextTranslationContainer'
import React from 'react'
import TotalGraph from './TotalGraph'
import { QuantitySelector } from 'components/item/Quantity'
import { useLang } from 'hooks'

const DivideEqually = ({completeOrder, value: defaultValue, setValue: setDefaultValue = () => {}, split}) => {
    const {isArabic} = useLang()
    const handleDecrease = (key) => {
        if (defaultValue[key] > 1) {
            const updateValue = { ...defaultValue, [key]:  Math.max(1, defaultValue[key] - 1)}
            if (key === "peopleAtTable"){
                updateValue["forPeople"] = 1
                if(defaultValue[key] - 1 === 0){
                  updateValue["peopleAtTable"] = 1
                }
            }
            setDefaultValue(updateValue);
        }
      };
      
      const handleIncrease = (key) => {
        const check = key === "forPeople" && (defaultValue[key] + (split?.splittedforPeople ?? 0)) === defaultValue["peopleAtTable"];
        const updateValue = { ...defaultValue, [key]: check ? defaultValue[key] : defaultValue[key] + 1 };
        if(key==="peopleAtTable"){
          updateValue["forPeople"] = 1
        }
        setDefaultValue(updateValue);
      };

  return (
    <>
          {/* <TranslationText text="Select Amount" className="text-20x font-semibold text-dark-blue-900" /> */}
          <TotalGraph split={{...split , ...defaultValue, orderGrossAmount:completeOrder?.orderGrossAmount}} />
          <div className={`flex items-center text-17x justify-between mt-4 ${isArabic ? 'flex-row-reverse' : ''}`}>
              <TranslationText text="People at your table" />
              <QuantitySelector
               value={defaultValue?.peopleAtTable}
               disable={split?.already ?? false}
               showDisableMessage={false}
               wrapperStyleProps={{style:{padding: '0 12px', width: '76px'}}}
               quantityStyleProps={{style:{width: '24px', margin:"0", textAlign: 'center'}}}
               decreaseQuantity={() => handleDecrease('peopleAtTable')}
               increaseQuantity={() => handleIncrease('peopleAtTable')}
              />
          </div>
          <div className={`flex items-center text-17x justify-between ${isArabic ? 'flex-row-reverse' : ''}`}>
              <TranslationText text="People you pay for" />
              <QuantitySelector
               value={defaultValue?.forPeople}
               wrapperStyleProps={{style:{padding: '0 12px', width: '76px'}}}
               quantityStyleProps={{style:{width: '24px', margin:"0", textAlign: 'center'}}}
               decreaseQuantity={() => handleDecrease('forPeople')}
               increaseQuantity={() => handleIncrease('forPeople')}
              />
          </div>
    </>
  )
}

export default DivideEqually